// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paragraph":"css-1hGTU40OlW","paragraph__inherit":"css-1tGs2BWx3N"};